import React, { useEffect } from "react";
// react-redux
import { useDispatch, useSelector } from "react-redux";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
// components
import PostCard from "../../components/PostCard/PostCard";
// action
import {
  fetchPosts,
  fetchCategoryPosts,
} from "../../store/actions/WordPressApiAction";
// styles
import styles from "./PostsViewStyle";
const useStyles = makeStyles(styles);
/**
 * 記事一覧表示画面のコンポーネント
 */
export default function PostsView(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const postsData = useSelector((state) => state.fetchReducer);

  useEffect(() => {
    console.log("記事一覧dispatch");
    if (props.categoryId) {
      dispatch(fetchCategoryPosts(1, props.categoryId));
    } else {
      dispatch(fetchPosts(1));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.categoryId]);

  /**
   * Pagenation機能でボタンが押された時に、ページを変更する関数。
   * あるカテゴリーの一覧からPagenation機能で別ページを選択した場合、そのカテゴリーの選択したページ一覧を表示する。
   * @param {*} event
   * @param {number} page
   */
  function changePage(event, page) {
    if (postsData.categoryId === -1) {
      dispatch(fetchPosts(page));
    } else {
      dispatch(fetchCategoryPosts(page, postsData.categoryId));
    }
  }
  return (
    <div className={classes.postsViewContainer}>
      {postsData.posts.map((item) => {
        return (
          <PostCard
            title={item.title.rendered}
            imgURL={item._embedded["wp:featuredmedia"][0].source_url}
            articleURL={item.link}
            postDate={item.date}
            slug={item.slug}
            key={item.id}
            siteURL={props.basicInfo.site_url}
          />
        );
      })}
      <Grid item xs={12}>
        <Pagination
          count={Number(postsData.totalPageNum)}
          defaultPage={1}
          page={postsData.fetchPageNum}
          color="primary"
          className={classes.pagenation}
          onChange={(event, page) => changePage(event, page)}
          renderItem={(item) => (
            <PaginationItem {...item} className={classes.pagenationItem} />
          )}
        />
      </Grid>
    </div>
  );
}
